"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const element_ui_1 = require("element-ui");
const vue_demi_1 = require("vue-demi");
// 引入 Element UI 组件样式
const webapi_1 = require("@fegobull/webapi");
require("element-ui/lib/theme-chalk/option.css");
require("element-ui/lib/theme-chalk/select.css");
const i18n_1 = tslib_1.__importDefault(require("../../../i18n"));
const utils_1 = require("../../common/utils");
const DatePickerDropdown_vue_1 = tslib_1.__importDefault(require("./DatePickerDropdown.vue"));
const DatePickerPopup_vue_1 = tslib_1.__importDefault(require("./DatePickerPopup.vue"));
const PopupSelect_vue_1 = tslib_1.__importDefault(require("./PopupSelect.vue"));
const TimeSlotPopup_vue_1 = tslib_1.__importDefault(require("./TimeSlotPopup.vue"));
// import request from '../assets/scripts/request';
const { usePageType, useToast } = webapi_1.use;
exports.default = (0, vue_demi_1.defineComponent)({
    name: 'ReservationForm',
    components: {
        ElSelect: element_ui_1.Select,
        ElOption: element_ui_1.Option,
        DatePickerDropdown: DatePickerDropdown_vue_1.default,
        DatePickerPopup: DatePickerPopup_vue_1.default,
        TimeSlotPopup: TimeSlotPopup_vue_1.default,
        PopupSelect: PopupSelect_vue_1.default
    },
    props: {
        configData: {
            type: Object,
            required: true
        },
        moduleName: {
            type: String,
            required: true
        },
        // 用户已有的预约记录列表（用于判断时段是否已预约）
        reservationList: {
            type: Array,
            default: () => []
        }
    },
    emits: ['submit', 'view-records'],
    // eslint-disable-next-line max-lines-per-function
    setup(props, { emit }) {
        const { isPC } = usePageType();
        // 是否有预约记录
        const hasReservationRecords = (0, vue_demi_1.computed)(() => {
            return props.reservationList && props.reservationList.length > 0;
        });
        // 查看预约记录
        const handleViewRecords = () => {
            emit('view-records');
        };
        // 弹窗显示状态（移动端使用）
        const datePickerVisible = (0, vue_demi_1.ref)(false);
        const timeSlotPickerVisible = (0, vue_demi_1.ref)(false);
        // 表单数据
        const formData = (0, vue_demi_1.ref)({
            activityKey: '',
            date: '',
            rangeKey: '',
            ext1: null, // 单选时是字符串，多选时是数组
            ext2: null // 单选时是字符串，多选时是数组
        });
        // 表单配置
        const formConfig = (0, vue_demi_1.computed)(() => {
            var _a;
            return ((_a = props.configData) === null || _a === void 0 ? void 0 : _a.formConfig) || [];
        });
        // 是否有表单项目
        const hasFormItems = (0, vue_demi_1.computed)(() => {
            return formConfig.value && formConfig.value.length > 0;
        });
        // 活动列表
        const activityList = (0, vue_demi_1.computed)(() => {
            var _a;
            return ((_a = props.configData) === null || _a === void 0 ? void 0 : _a.list) || [];
        });
        // 是否有 date 字段
        const hasDateField = (0, vue_demi_1.computed)(() => {
            return formConfig.value.some((item) => item.field === 'date');
        });
        // rangeKey 配置项
        const rangeConfigItem = (0, vue_demi_1.computed)(() => {
            return formConfig.value.find((item) => item.field === 'rangeKey');
        });
        // 当前选中的活动
        const selectedActivity = (0, vue_demi_1.computed)(() => {
            if (!formData.value.activityKey) {
                return null;
            }
            return activityList.value.find((item) => item.activityKey === formData.value.activityKey);
        });
        // 当前选中的日期对应的 DateSlot
        const selectedDateSlot = (0, vue_demi_1.computed)(() => {
            if (!selectedActivity.value || !formData.value.date) {
                return null;
            }
            return selectedActivity.value.availableDates.find((item) => item.date === formData.value.date);
        });
        // activityKey 选项
        const activityOptions = (0, vue_demi_1.computed)(() => {
            return activityList.value.map((item) => {
                const name = (0, utils_1.getLocalText)(item.localText, 'name');
                return {
                    label: name || item.activityKey,
                    value: item.activityKey
                };
            });
        });
        // date 选项（根据语言自动选择日期格式）- 移动端使用
        const dateOptions = (0, vue_demi_1.computed)(() => {
            if (!selectedActivity.value) {
                return [];
            }
            return selectedActivity.value.availableDates.map((dateSlot) => {
                const formattedDate = (0, utils_1.formatDate)(dateSlot.date);
                return {
                    label: formattedDate,
                    value: dateSlot.date
                };
            });
        });
        /**
         * 检查指定时段是否已被用户预约（且未取消）
         */
        const isTimeSlotReserved = (activityKey, date, rangeKey) => {
            if (!props.reservationList || props.reservationList.length === 0) {
                return false;
            }
            return props.reservationList.some((record) => {
                // 匹配 activityKey + date + rangeKey
                const isMatch = record.activity_key === activityKey && record.date === date && record.range_key === rangeKey;
                // 未取消：canceled_at 为 0 或 null/undefined
                const isNotCanceled = !record.canceled_at || record.canceled_at === 0;
                return isMatch && isNotCanceled;
            });
        };
        // rangeKey 选项
        const rangeOptions = (0, vue_demi_1.computed)(() => {
            if (!selectedDateSlot.value) {
                return [];
            }
            const currentActivityKey = formData.value.activityKey;
            const currentDate = formData.value.date;
            return selectedDateSlot.value.timeRanges.map((timeSlot) => {
                // 使用 start 和 end 字段显示活动时间
                const timeStr = `${timeSlot.start} - ${timeSlot.end}`;
                // 判断是否禁用：已满、已过期、或已被预约
                const isFullOrExpired = timeSlot.status === 'full' || timeSlot.status === 'expired';
                const isReserved = isTimeSlotReserved(currentActivityKey, currentDate, timeSlot.rangeKey);
                const isDisabled = isFullOrExpired || isReserved;
                // 生成 label，如果 disabled 则在后面拼接原因（优先级：已预约 > 已满 > 已过期）
                let label = timeStr;
                if (isDisabled) {
                    let reason = '';
                    // 优先级：已预约 > 已满 > 已过期
                    if (isReserved) {
                        reason = (0, i18n_1.default)('time_slot_reserved');
                    }
                    else if (timeSlot.status === 'full') {
                        reason = (0, i18n_1.default)('time_slot_full');
                    }
                    else if (timeSlot.status === 'expired') {
                        reason = (0, i18n_1.default)('status_expired');
                    }
                    if (reason) {
                        label = `${timeStr} (${reason})`;
                    }
                }
                return {
                    label,
                    value: timeSlot.rangeKey,
                    disabled: isDisabled
                };
            });
        });
        /**
         * 检查指定活动的指定日期是否有可用时段
         * @param activity 活动配置
         * @param dateSlot 日期配置
         * @returns 是否有可用时段
         */
        const hasAvailableTimeSlot = (activity, dateSlot) => {
            if (!dateSlot.timeRanges || dateSlot.timeRanges.length === 0) {
                return false;
            }
            return dateSlot.timeRanges.some((timeSlot) => {
                const isFullOrExpired = timeSlot.status === 'full' || timeSlot.status === 'expired';
                if (isFullOrExpired) {
                    return false;
                }
                const isReserved = isTimeSlotReserved(activity.activityKey, dateSlot.date, timeSlot.rangeKey);
                return !isReserved;
            });
        };
        /**
         * 获取指定活动的可用日期列表（只包含有可用时段的日期）
         * @param activity 活动配置
         * @returns 可用日期列表
         */
        const getAvailableDates = (activity) => {
            if (!(activity === null || activity === void 0 ? void 0 : activity.availableDates)) {
                return [];
            }
            return activity.availableDates.filter((dateSlot) => hasAvailableTimeSlot(activity, dateSlot));
        };
        /**
         * 获取指定日期的可用时段列表
         * @param activityKey 活动标识
         * @param dateSlot 日期配置
         * @returns 可用时段列表
         */
        const getAvailableTimeSlots = (activityKey, dateSlot) => {
            if (!(dateSlot === null || dateSlot === void 0 ? void 0 : dateSlot.timeRanges)) {
                return [];
            }
            return dateSlot.timeRanges.filter((timeSlot) => {
                const isFullOrExpired = timeSlot.status === 'full' || timeSlot.status === 'expired';
                if (isFullOrExpired) {
                    return false;
                }
                const isReserved = isTimeSlotReserved(activityKey, dateSlot.date, timeSlot.rangeKey);
                return !isReserved;
            });
        };
        /**
         * 初始化时自动选中唯一选项
         * 仅在页面加载时执行一次
         */
        const autoSelectSingleOptions = () => {
            // 1. 检查活动：如果只有一个活动，自动选中
            if (activityList.value.length === 1 && !formData.value.activityKey) {
                const singleActivity = activityList.value[0];
                formData.value.activityKey = singleActivity.activityKey;
                console.log('[ReservationForm] 自动选中唯一活动:', singleActivity.activityKey);
                // 2. 检查日期：如果只有一个可用日期，自动选中
                const availableDates = getAvailableDates(singleActivity);
                if (availableDates.length === 1 && !formData.value.date) {
                    const singleDate = availableDates[0];
                    formData.value.date = singleDate.date;
                    console.log('[ReservationForm] 自动选中唯一日期:', singleDate.date);
                    // 3. 检查时段：如果只有一个可用时段，自动选中
                    const availableTimeSlots = getAvailableTimeSlots(singleActivity.activityKey, singleDate);
                    if (availableTimeSlots.length === 1 && !formData.value.rangeKey) {
                        const singleTimeSlot = availableTimeSlots[0];
                        formData.value.rangeKey = singleTimeSlot.rangeKey;
                        console.log('[ReservationForm] 自动选中唯一时段:', singleTimeSlot.rangeKey);
                    }
                }
            }
        };
        // 是否可以提交
        const canSubmit = (0, vue_demi_1.computed)(() => {
            return Boolean(formData.value.activityKey && formData.value.date && formData.value.rangeKey);
        });
        // 日期是否可选择（需要先选择 activityKey）
        const canSelectDate = (0, vue_demi_1.computed)(() => {
            return Boolean(formData.value.activityKey);
        });
        // 时段是否可选择（需要先选择日期）
        const canSelectTimeSlot = (0, vue_demi_1.computed)(() => {
            return Boolean(formData.value.date);
        });
        // 提交按钮文案
        const submitBtnText = (0, vue_demi_1.computed)(() => {
            return (0, i18n_1.default)('submitBtn');
        });
        /**
         * 获取 placeholder
         */
        const getPlaceholder = (configItem) => {
            const placeholder = (0, utils_1.getLocalText)(configItem.localText, 'placeholder');
            if (placeholder) {
                return placeholder;
            }
            // 如果没有配置 placeholder，使用默认值
            const field = configItem.field;
            if (field === 'activityKey') {
                return (0, i18n_1.default)('placeholder_activity');
            }
            if (field === 'date') {
                return (0, i18n_1.default)('placeholder_date');
            }
            if (field === 'rangeKey') {
                return (0, i18n_1.default)('placeholder_time');
            }
            if (field === 'ext1') {
                return (0, i18n_1.default)('placeholder_ext1');
            }
            if (field === 'ext2') {
                return (0, i18n_1.default)('placeholder_ext2');
            }
            return '';
        };
        /**
         * 获取 ext1/ext2 的选项
         * value 使用 option.key，label 使用对应语言的文本
         */
        const getExtOptions = (configItem) => {
            if (!configItem.options || !Array.isArray(configItem.options)) {
                return [];
            }
            return configItem.options.map((option) => {
                const label = (0, utils_1.getFormOptionText)(option);
                return {
                    label: label || '',
                    value: option.key
                };
            });
        };
        /**
         * 处理 activityKey 变化
         */
        const handleActivityChange = () => {
            // 清空下级选择
            formData.value.date = '';
            formData.value.rangeKey = '';
        };
        /**
         * 处理 PC 端日期选择变化
         */
        const handlePcDateChange = (date) => {
            formData.value.date = date;
            // 清空时段选择
            formData.value.rangeKey = '';
        };
        /**
         * 处理 date 变化
         */
        const handleDateChange = () => {
            // 清空 rangeKey
            formData.value.rangeKey = '';
        };
        /**
         * 处理 rangeKey 变化
         */
        const handleRangeChange = () => {
            // 不需要特殊处理
        };
        /**
         * 获取日期显示文本（用于移动端触发按钮）
         */
        const getDateDisplayText = () => {
            if (!formData.value.date) {
                const dateConfigItem = formConfig.value.find((item) => item.field === 'date');
                return getPlaceholder(dateConfigItem);
            }
            const selectedOption = dateOptions.value.find((item) => item.value === formData.value.date);
            return selectedOption ? selectedOption.label : '';
        };
        /**
         * 获取时段显示文本（用于移动端触发按钮）
         */
        const getTimeSlotDisplayText = () => {
            if (!formData.value.rangeKey) {
                return getPlaceholder(rangeConfigItem.value);
            }
            const selectedOption = rangeOptions.value.find((item) => item.value === formData.value.rangeKey);
            return selectedOption ? selectedOption.label : '';
        };
        /**
         * 获取日期样式
         */
        const getDateStyle = () => {
            const dateConfigItem = formConfig.value.find((item) => item.field === 'date');
            return (dateConfigItem === null || dateConfigItem === void 0 ? void 0 : dateConfigItem.dateStyle) || 'monthFirst';
        };
        /**
         * 处理日期确认（移动端弹窗）
         */
        const handleDateConfirm = (date) => {
            formData.value.date = date;
            handleDateChange();
        };
        /**
         * 处理时段确认（移动端弹窗）
         */
        const handleTimeSlotConfirm = (rangeKey) => {
            formData.value.rangeKey = rangeKey;
            handleRangeChange();
        };
        /**
         * 处理日期点击（校验是否可选择）
         */
        const handleDateClick = () => {
            if (!canSelectDate.value) {
                // Toast.info($t('toast_select_activity_first'));
                return;
            }
            datePickerVisible.value = true;
        };
        /**
         * 处理时段点击（校验是否可选择）
         */
        const handleTimeSlotClick = () => {
            if (!canSelectDate.value) {
                // Toast.info($t('toast_select_activity_first'));
                return;
            }
            if (!canSelectTimeSlot.value) {
                // Toast.info($t('toast_select_date_first'));
                return;
            }
            timeSlotPickerVisible.value = true;
        };
        /**
         * 处理提交
         */
        const handleSubmit = async () => {
            if (!canSubmit.value) {
                return;
            }
            try {
                const submitData = {
                    moduleName: props.moduleName,
                    activityKey: formData.value.activityKey,
                    date: formData.value.date,
                    rangeKey: formData.value.rangeKey,
                    // eslint-disable-next-line max-len
                    ext1: (formData.value.ext1 &&
                        (Array.isArray(formData.value.ext1)
                            ? formData.value.ext1.join(',')
                            : formData.value.ext1)) ||
                        undefined,
                    // eslint-disable-next-line max-len
                    ext2: (formData.value.ext2 &&
                        (Array.isArray(formData.value.ext2)
                            ? formData.value.ext2.join(',')
                            : formData.value.ext2)) ||
                        undefined
                };
                // TODO: 调用创建预约接口
                // const { request } = require('../assets/scripts/request');
                // await request.createReservation(submitData);
                // 触发提交事件
                emit('submit', submitData);
            }
            catch (error) {
                console.error('[common-reservation] 提交预约失败:', error);
            }
        };
        // Watch for changes in configData to reset form and auto-select single options
        (0, vue_demi_1.watch)(() => props.configData, (newVal) => {
            if (newVal) {
                formData.value = {
                    activityKey: '',
                    date: '',
                    rangeKey: '',
                    ext1: null,
                    ext2: null
                };
                // 数据加载完成后，尝试自动选中唯一选项
                (0, vue_demi_1.nextTick)(() => {
                    autoSelectSingleOptions();
                });
            }
        }, { immediate: true });
        /**
         * 根据 formConfig 中的 selectMode 转换 ext 字段值
         * 如果是多选模式且值为逗号分隔字符串，则转回数组
         * @param field 字段名（ext1 或 ext2）
         * @param value 待转换的值
         * @returns 转换后的值
         */
        const convertExtValue = (field, value) => {
            if (value === null) {
                return null;
            }
            // 如果已经是数组，无需转换
            if (Array.isArray(value)) {
                return value;
            }
            // 查找 formConfig 中对应字段的配置
            const configItem = formConfig.value.find((item) => item.field === field);
            // 如果是多选模式，将逗号分隔字符串转为数组
            if (configItem && configItem.selectMode === 'multiple' && typeof value === 'string') {
                return value.split(',');
            }
            return value;
        };
        /**
         * 设置表单数据（用于恢复缓存的表单草稿）
         * @param data 表单数据
         */
        const setFormData = (data) => {
            if (data.activityKey !== undefined) {
                formData.value.activityKey = data.activityKey;
            }
            if (data.date !== undefined) {
                formData.value.date = data.date;
            }
            if (data.rangeKey !== undefined) {
                formData.value.rangeKey = data.rangeKey;
            }
            if (data.ext1 !== undefined) {
                formData.value.ext1 = convertExtValue('ext1', data.ext1);
            }
            if (data.ext2 !== undefined) {
                formData.value.ext2 = convertExtValue('ext2', data.ext2);
            }
        };
        /**
         * 获取当前表单数据
         * @returns 表单数据
         */
        const getFormData = () => {
            return Object.assign({}, formData.value);
        };
        return {
            $t: i18n_1.default,
            isPC,
            datePickerVisible,
            timeSlotPickerVisible,
            // PC 端日期选择
            handlePcDateChange,
            // 表单相关
            formData,
            formConfig,
            hasFormItems,
            activityList,
            hasDateField,
            rangeConfigItem,
            selectedActivity,
            selectedDateSlot,
            activityOptions,
            dateOptions,
            rangeOptions,
            canSubmit,
            canSelectDate,
            canSelectTimeSlot,
            submitBtnText,
            getPlaceholder,
            getExtOptions,
            getDateDisplayText,
            getTimeSlotDisplayText,
            getDateStyle,
            handleActivityChange,
            handleDateChange,
            handleDateConfirm,
            handleDateClick,
            handleRangeChange,
            handleTimeSlotConfirm,
            handleTimeSlotClick,
            handleSubmit,
            // 预约记录按钮
            hasReservationRecords,
            handleViewRecords,
            // 暴露给父组件使用
            setFormData,
            getFormData,
            autoSelectSingleOptions
        };
    }
});
//# sourceMappingURL=data:application/json;base64,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